import { Modal } from '@carbon/react';
import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Logout } from '@carbon/icons-react';

import styles from './Logout.module.scss';

import sharedMessages from 'Components/utils/sharedMessages';
import { getStorage } from 'hooks/useStorage';
import { USER_TOKEN_KEY } from 'hooks/keys';

const { removeItem } = getStorage('local');

const LogoutHandler = () => {
    const intl = useIntl();
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const onOpen = () => setIsOpen(true);
    const onClose = () => setIsOpen(false);

    const onSubmit = () => {
        removeItem(USER_TOKEN_KEY);
        setIsOpen(false);
        navigate('/login');
    };

    return (
        <div className={styles.logoutContainer}>
            <button 
                type="button" 
                role="menuitem"
                className={styles.logoutBtn} 
                onClick={onOpen}
            >
                <Logout size={20} />
                <span>{intl.formatMessage(messages.logout)}</span>
            </button>
            <Modal
                preventCloseOnClickOutside
                open={isOpen}
                onRequestClose={onClose}
                onRequestSubmit={onSubmit}
                danger
                modalHeading={intl.formatMessage(messages.heading)}
                primaryButtonText={intl.formatMessage(sharedMessages.submit)}
                closeButtonLabel={intl.formatMessage(sharedMessages.cancel)}
                secondaryButtonText={intl.formatMessage(sharedMessages.back)}
            />
        </div>
    );
};

const messages = defineMessages({
    logout: {
        id: 'src.Components.LeftMenuPanel.Logout.LogoutHandler.logout',
        defaultMessage: 'Wyloguj się',
    },
    heading: {
        id: 'src.Components.LeftMenuPanel.Logout.LogoutHandler.heading',
        defaultMessage: 'Czy na pewno chcesz się wylogować?',
    },
});

export default LogoutHandler;
